const breadcrumb = {
  state: {
    breadcrumbData: []
  },
  mutations: {
    SET_BREADCRUMDATA: (state, breadcrumb) => {
      state.breadcrumbData = breadcrumb
    }
  }
}
export default breadcrumb
